import http from "./http_common";

class AuthService {
  queryString(payload) {
    return Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
  }

  ChatbotTokenAuthentication(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
    return http.get(`/oauth/token?${queryString}`);
  }


  ChatbotLogin(data) {
    return http.post("/Login/", data);
  }

  getMyPrescription(payload) {
    var queryString = this.queryString(payload);
    return http.get(`patientDocument/list/filter?${queryString}`);
  }
  getSharePrescription(id) {
    return http.get(`prescriptionDetails/list/filter?refNumber=${id}`);
  }
  getMyPrescriptionView(payload) {
    var queryString = this.queryString(payload);
    return http.get(`consultation/list/filter?${queryString}`);
  }
  getHSMyPrescriptionView(payload) {
    var queryString = this.queryString(payload);
    return http.get(`consultation/health-summary/list/filter?${queryString}`);
  }
  getMyReport(payload) {
    var queryString = this.queryString(payload);
    return http.get(`patientDocument/list/filter?${queryString}`);
  }
  getHSMyReport(payload) {
    var queryString = this.queryString(payload);
    return http.get(`patientDocument/health-summar/list/filter?${queryString}`);
  }
  getHSLabReport(payload) {
    var queryString = this.queryString(payload);
    return http.get(`labTestOrderResult/health-summar/getall-labresults?${queryString}`);
  }
  getClinicData(payload) {
    return http.get(`/Clinic_Master/list/filter?clinic_Id=${payload}`);
  }
  stateMaster() {
    return http.get(`/stateMaster/list/filter?status=1`);
  }
  ChangePassword(payload) {
    return http.post(`patientpassword-config/change-password/`, payload);
  }
  getUser(payload) {
    return http.get(`user/list/filter?userId=${payload}`);
  }
  getUserData(payload) {
    var queryString = this.queryString(payload);
    return http.get(`user/getStampAndSignature?${queryString}`);
  }
  getHSUserData(payload) {
    var queryString = this.queryString(payload);
    return http.get(`user/health-summar/getStampAndSignature?${queryString}`);
  }
  getHospitalAccountData(id) {
    return http.get(`/accountMaster/list/filter?account_Id=${id}`);
  }
  getHospitalAccountDataLogo(id) {
    var queryString = this.queryString(id);
    return http.get(`/accountMaster/getLogo?${queryString}`);
  }
  getHSHospitalAccountDataLogo(id) {
    var queryString = this.queryString(id);
    return http.get(`/accountMaster/health-summar/getLogo?${queryString}`);
  }
}

export default new AuthService();
